export type ReportStatus = 'draft' | 'pending' | 'returned' | 'approved';

export function isReportStatus(value: unknown): value is ReportStatus {
  return value === 'draft' || value === 'pending' || value === 'returned' || value === 'approved';
}

export function reportStatus(raw: unknown): ReportStatus {
  if (raw === 'draft' || raw === 'pending' || raw === 'returned' || raw === 'approved') {
    return raw;
  }
  if (raw === 'submitted') return 'pending';
  return 'pending';
}

export function statusLabel(status: ReportStatus): string {
  if (status === 'draft') return 'Draft';
  if (status === 'pending') return 'Pending review';
  if (status === 'returned') return 'Returned';
  return 'Approved';
}

/** Authors can save and submit. Only an admin can approve or return a report. */
export function authorizeStatus(
  requested: unknown,
  role: 'instructor' | 'admin',
  current?: ReportStatus
): ReportStatus | string {
  const next = reportStatus(requested);
  if (requested === 'draft') {
    if (current && current !== 'draft') return current;
    return 'draft';
  }
  if (next === 'approved' || next === 'returned') {
    if (role === 'admin' || current === next) return next;
    return 'Only an admin can set that status';
  }
  return 'pending';
}
